/** Default in-app entry (chat). */
export const APP_HOME = "/";

/** Chat home; `/heute` redirects here. */
export const HEUTE = "/heute";
export const ARCHIV = "/archiv";
export const PLAN = "/plan";
export const ENTDECKEN = "/entdecken";
